import React from 'react';
import ReactDOM from 'react-dom';
import { Rnd } from 'react-rnd';
import FontAwesome from 'react-fontawesome';

import { roundNumber, copy } from './functions.js';


class PreviewLayer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            height: null,
            width: null,
            contentLayer: copy(this.props.contentLayer)
        }
        this.handleLayerMove = this.handleLayerMove.bind(this);
        this.handleLayerMoveEnd = this.handleLayerMoveEnd.bind(this);
        this.handleLayerResize = this.handleLayerResize.bind(this);
        this.handleLayerResizeEnd = this.handleLayerResizeEnd.bind(this);
    }

    handleLayerResize(e, dir, ref, delta, pos) {

        const layer = this.state.contentLayer;
        layer.dimensions.height = ref.offsetHeight;
        layer.dimensions.width = ref.offsetWidth;
        this.setState({
            contentLayer: layer
        })
    }

    handleLayerResizeEnd(e, dir, ref, delta, pos) {

        const layer = this.state.contentLayer;
        layer.dimensions.height = ref.offsetHeight;
        layer.dimensions.width = ref.offsetWidth;

        this.props.onContentLayerChange(layer);
    }

    handleLayerMove(e, data) {

        const layer = this.state.contentLayer;
        layer.dimensions.posY = data.y;
        layer.dimensions.posX = data.x;
        this.setState({
            contentLayer: layer
        })
    }

    handleLayerMoveEnd(e, data) {

        const layer = this.state.contentLayer;
        layer.dimensions.posY = data.y;
        layer.dimensions.posX = data.x;


        this.props.onContentLayerChange(layer);
    }

    componentDidMount() {
        if (this.layerResizeWrapper !== undefined && this.layerResizeWrapper !== null)
        {
            const width = this.layerResizeWrapper.clientWidth;
            const height = this.layerResizeWrapper.clientHeight;
    
            if (this.state.width !== width || this.state.height !== height)
            {
                this.setState({
                    height: height,
                    width: width,
                });
            }
        }
    }

    componentDidUpdate() {
        if (this.layerResizeWrapper !== undefined && this.layerResizeWrapper !== null)
        {
            const width = this.layerResizeWrapper.clientWidth;
            const height = this.layerResizeWrapper.clientHeight;
    
            if (this.state.width !== width || this.state.height !== height)
            {
                this.setState({
                    height: height,
                    width: width,
                });
            }
        }
    }

    render() {

        if (this.state.contentLayer.content === '' || this.state.contentLayer.content === null)
            return null;

        let content = null;
        if (this.props.contentLayer.type = 'text')
            content = this.props.contentLayer.content;
    
        const layerStyle = {
            color: this.props.activeColor.color_hex
        };

        const layerPositionStyle = {
            top: this.state.contentLayer.dimensions.posY.toString() + 'px',
            left: this.state.contentLayer.dimensions.posX.toString()  + 'px'
        }; 

        const layerActiveStyle = {
            width: this.state.contentLayer.dimensions.width,
            height: this.state.contentLayer.dimensions.height,
            top: '0px',
            left: '0px'
        };

        const layerMaxBounds = {
            top: this.state.contentLayer.maxDimensions.posY.toString() + 'px',
            left: this.state.contentLayer.maxDimensions.posX.toString() + 'px',
            width: this.state.contentLayer.maxDimensions.width.toString() + 'px',
            height: this.state.contentLayer.maxDimensions.height.toString() + 'px',
        }



        let layerMoveStyle = {
            width: this.state.contentLayer.dimensions.width,
            height: this.state.contentLayer.dimensions.height,
            top: this.state.contentLayer.dimensions.posX,
            left: this.state.contentLayer.dimensions.posY,
        }

        let layerRotation = {};
        let layerResize = {};
        if (this.state.width !== null)
        {
            const scaleX = this.state.contentLayer.dimensions.width / this.state.width;
            const scaleY = this.state.contentLayer.dimensions.height / this.state.height;
            
            layerResize.WebkitTransform = 'scale(' + scaleX + ',' + scaleY + ')';
            layerResize.OTransform = 'scale(' + scaleX + ',' + scaleY + ')';
            layerResize.MsTransform = 'scale(' + scaleX + ',' + scaleY + ')';
            layerResize.MozTransform = 'scale(' + scaleX + ',' + scaleY + ')';
            layerResize.transform = 'scale(' + scaleX + ',' + scaleY + ')';
            layerResize.WebkitTransformOrigin = 'top left';
            layerResize.OTransformOrigin = 'top left';
            layerResize.MsTransformOrigin = 'top left';
            layerResize.MozTransformOrigin = 'top left';
            layerResize.transformOrigin = 'top left';
        }


        return (
            <div className="preview_layer" style={layerStyle}>
                <div className="layer_max_bounds" style={layerMaxBounds}></div>
                <div className="layer_position_wrapper" style={layerPositionStyle}>
                    <div className="layer_resize_wrapper" style={layerResize} ref={ (layerResizeWrapper) => this.layerResizeWrapper = layerResizeWrapper}>
                        <div className="layer_rotate_wrapper" style={layerRotation}>
                            <div className="layer_content_text" ref={ (layerResizeWrapperTest) => this.layerResizeWrapperTest = layerResizeWrapperTest}>{content}</div>
                        </div>
                    </div>
                </div>
                
                <Rnd
                    style={{ background: 'transparent' }}
                    default={{
                        x: layerMoveStyle.top,
                        y: layerMoveStyle.left,
                        width: layerMoveStyle.width,
                        height: layerMoveStyle.height
                    }}
                    resizeHandleClasses={{ bottomRight: 'layer_resize_handle fa fa-expand fa-flip-horizontal'}}
                    onDrag={this.handleLayerMove}
                    onDragStop={this.handleLayerMoveEnd}
                    onResize={this.handleLayerResize}
                    onResizeStop={this.handleLayerResizeEnd}
                    bounds='layer_max_bounds'
                    enableResizing={{ top:false, right:false, bottom:false, left:false, topRight:false, bottomRight:true, bottomLeft:false, topLeft:false }}
                >
                    <div className="layer_active_wrapper active" style={layerActiveStyle}></div>
              </Rnd>
            </div>
        );
    }
  }

export default PreviewLayer;




// WEBPACK FOOTER //
// ./src/PreviewLayer.js